import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '@/components/SEO';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function BuyEbookCancel() {
  return (
    <div>
      <SEO title="Order Cancelled" path="/single-handed/buy/cancel" />
      <section className="min-h-[60vh] flex items-center bg-slate-50">
        <div className="max-w-xl mx-auto px-4 py-16 text-center">
          <XCircle className="h-12 w-12 text-amber-500 mx-auto mb-5" />
          <h1 className="font-serif text-3xl md:text-4xl font-bold text-[#0b2545]">Order cancelled</h1>
          <p className="text-slate-600 mt-3 max-w-md mx-auto">
            You cancelled the PayPal checkout and no payment was taken. You can try again any time.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Button asChild className="bg-[#0b2545] hover:bg-[#123a6b] text-white">
              <Link to="/single-handed/buy"><ArrowLeft className="mr-2 h-4 w-4" /> Try again</Link>
            </Button>
            <Button asChild variant="outline" className="border-[#0b2545] text-[#0b2545] hover:bg-[#0b2545] hover:text-white">
              <Link to="/single-handed">Back to Single Handed</Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
